import React from 'react'
import { Check } from '@mui/icons-material'

const RenderCheckCell = ({ value }) => {
  if (value === true) return <Check sx={{ color: 'text.secondary' }} />
  return ''
}

export default RenderCheckCell
